import { millisecondsPer } from '@art-suite/art-core-ts';

export const ScanOfflineDataMinTtlOnAccessMs = millisecondsPer.day * 2;
export const ScanOfflinePrepCheckTtl = millisecondsPer.day; // less than OfflineScanDataMinTtlOnAccessMs
